var exports = {
  "hJ": "CharacterCounter.module__counter___a1RTQ1",
  "$s": "CharacterCounter.module__counterButton___a1RTQ1" + " " + "CharacterCounter.module__counter___a1RTQ1",
  "N1": "CharacterCounter.module__counterSpan___a1RTQ1" + " " + "CharacterCounter.module__counter___a1RTQ1",
  "jL": "CharacterCounter.module__textDanger___a1RTQ1",
  "gF": "CharacterCounter.module__textTertiary___a1RTQ1",
};

module.exports = exports;
